<div class="mat-dialog-draggable-main-content mat-dialog-signature-process">
    <div class="mat-dialog-draggable-header">
      <h2 mat-dialog-title mat-dialog-draggable-title>{{'title.send_contract_sms_result' | translate}}
        <button type="button" class="close" aria-label="Close" (click)="onNoClick()" cdkFocusInitial>
          <span aria-hidden="true">&times;</span>
        </button>
      </h2>
      <mat-divider style="padding-bottom: 1rem;"></mat-divider>
    </div>
    <mat-dialog-content>
      <p>{{ 'resend_contract.sms_result_table.contract_name' | translate }}: {{ data.document.name }}</p>
      <div class="mat-table-container">
        <mat-table [dataSource]="dataSource" class="mat-table-col-extra-sm">

          <!-- STT -->
          <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef
              class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="max-width: 10%;">
              {{'headertable.stt' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center" style="max-width: 10%;">
              <span class="fix-width">{{dataSource.indexOf(element)+1}}</span>
            </mat-cell>
          </ng-container>

          <!-- Khách hàng -->
          <ng-container matColumnDef="customer">
            <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="min-width: 30%;">
              {{'headertable.customer_name' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="min-width: 30%;"
              matTooltip="{{element.fullName}}">
              <span class="fix-width">{{element.fullName}}</span>
            </mat-cell>
          </ng-container>

          <!-- Trạng thái gửi SMS -->
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="width: 20%;">
              {{'headertable.send_sms_status' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="width: 20%;"
              class="mat-cell-non-boder-right-bottom number-cell-center">
              <nz-tag *ngIf="!element.status" style="margin-right: 0px;" [nzColor]="'blue'">{{'resend_contract.sms_result_table.sms_result.status_done' | translate}}</nz-tag>
              <nz-tag *ngIf="element.status" style="margin-right: 0px;" [nzColor]="'red'">{{'resend_contract.sms_result_table.sms_result.status_error' | translate}}</nz-tag>
            </mat-cell>
          </ng-container>

          <!-- Ghi chú -->
          <ng-container matColumnDef="note">
            <mat-header-cell *matHeaderCellDef class="mat-header-cell-center" style="min-width: 30%;">
              {{'headertable.note' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="min-width: 30%;"
              matTooltip="{{element.message}}">
              <span class="fix-width">{{element.message}}</span>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row">
          </mat-row>
        </mat-table>
      </div>

    </mat-dialog-content>
    <div class="w-100 mat-dialog-draggable-footer">
      <mat-dialog-actions align="center">
        <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.close' | translate}}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
  
  
  